import { AfterViewChecked, Component, ElementRef, NgZone, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectHeaderComponent } from "../../../components/project-header/project-header.component";
import { DxButtonModule, DxTextBoxModule } from 'devextreme-angular';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { WikiService } from 'src/app/services/wiki.service';
import { DxScrollViewModule } from 'devextreme-angular';
import { environment } from 'src/environments/environment';
import { ScrollableService } from 'src/app/services/misc/scrollable.service';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
@Component({
    selector: 'app-wiki',
    templateUrl: './wiki-main.page.html',
    styleUrls: ['./wiki-main.page.css', '../wiki.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ProjectHeaderComponent, DxButtonModule, RouterModule, DxTextBoxModule]
})
export class WikiMainComponent implements AfterViewChecked {

  wikiSection : string;

  editPermission: any = AppGlobals.UserPermissions;

  maxTabLength: number = 0;

  tabs: any = []

  slideHtm: any;

  articles: any = [];
  pageBreadCrumb: any = { text: $localize`Wiki/`, href: window.location.href, layer: 0 }

  searchValue: any;

  searchFilter: any;
  backtoTopVisible: boolean = false

  constructor(
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private ngZone: NgZone, 
    private appGlobals: AppGlobals, 
    private wikiService: WikiService,
    private scrollableService: ScrollableService,
    private activityLog: ActivityLogService
    ) { 
      this.wikiSection = this.router.url.split('/')[2];
    }

  ngOnInit(): void {

/*     if (environment.isTestEnvironment === true) { */
      this.appGlobals.SetGlobalMenuIndex(8);
  /*   } else {
      this.appGlobals.SetGlobalMenuIndex(6);
    } */
    AppGlobals.clearBreadCrumbInLocalStorage();

    this.calculateMaxTabLength();
      this.appGlobals.$headerTitle.next($localize`:@@wiki:Wiki`) ;

    this.activityLog.logView({ Section: ActivitySection.WIKI, Detail: { section: this.wikiSection } });
    this.getPageData()

    
  };
    @ViewChild('wikimainscrollableDiv', { static: false }) scrollableDiv: ElementRef;
    hasInitialized = false;
    ngAfterViewChecked(): void {
      if(!this.hasInitialized && this.scrollableDiv){
        this.scrollableService.setScrollableElement(this.scrollableDiv);
        this.hasInitialized = true;
      }
    }

  async getPageData() {
    try{
      const result = await this.wikiService.getWikiArticles({wikiSection: this.wikiSection});
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.articles = result.wikiArticleItems;
        this.processArticlesStructure();
      }
      
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  search(e) {
    //   this.personGrid.instance.filter([this.searchFilter]);
  }

  canEditWiki(): boolean {
    if(this.wikiSection == 'manual'){
      const email : string = AppGlobals.LoggedInUserData.email;
      if(!email.includes('@tdc.co.za') && !email.includes('@gp-digital.io')){
        return false;
      }
    }
    return AppGlobals.UserPermissions.isAdministrator === true;
  };


  calculateMaxTabLength() {
    this.maxTabLength = Math.max(...this.tabs.map(tab => tab.text.length));
  }

  goTo(path: string): void {
    this.router.navigate([path]);
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  processArticlesStructure(): void {

  }
  setBreadCrumb(): void {
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  highlightText(text: string): string {
    if (this.searchValue && typeof text === 'string') {
      let index = text.toLowerCase().indexOf(this.searchValue.toLowerCase());
      if (index != -1) {
        let match = text.slice(index, index + this.searchValue.length);
        var searchMatchString = "<span class='search-text'>" + match + "</span>";
        text = text.split(match).join(searchMatchString);
      }
    }
    return text;
  }

  

}
